<template>
  <v-container
    id="wizard"
    tag="section"
  >
    <base-material-wizard-site
      v-model="tab"
      :available-steps="availableSteps"
      :items="tabs"
      class="mx-auto"
      @click:next="next"
      @click:prev="tab--"
    >
      <v-tab-item class="pb-12">
        <v-form
          ref="form1"
        >
          <div class="text-center display-1 font-weight-dark mb-6">
            New Unique POSTAL Site Name (Mail In/Postal site)
          </div>

          <v-row
            class="mx-auto"
            justify="space-around"
            style="max-width: 700px;"
          >
            <v-col
              cols="auto"
              class="text-center"
            >
              <v-card
                :class="sitename ? 'success--text' : 'grey--text'"
                class="mx-auto mt-0 d-inline-flex v-card--account"
                outlined
                height="106"
                width="106"
              >
                <v-icon
                  class="mx-auto"
                  size="88"
                >
                  mdi-truck
                </v-icon>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="sitename"
                :rules="rules"
                color="secondary"
                label="Site Name *"
              />
              <v-autocomplete
                v-model="group"
                v-validate="'required'"
                :autocomplete="Date.now()"
                :error-messages="errors.collect('address.safeid')"
                :items="grouplist"
                color="secondary"
                data-vv-name="group"
                label="Group*"
                validate-on-blur
              />
              <v-menu
                ref="menu"
                v-model="menueodtime"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="onboardEodTime"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="onboardEodTime"
                    label="EOD Time"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  v-if="menueodtime"
                  v-model="onboardEodTime"
                  header-color="blue"
                  format="24hr"
                  full-width
                  @click:minute="$refs.menu.save(onboardEodTime)"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
      </v-tab-item>

      <v-tab-item class="pb-12">
        <form
          action=""
          data-vv-scope="safe"
        >
          <div class="text-center display-1 font-weight-dark mb-6">
            Add a POSTAL safe to this new site. A POSTAL safe name has been generated.
          </div>

          <v-row
            class="mx-auto"
            justify="space-around"
            style="max-width: 700px;"
          >
            <v-col
              cols="auto"
              class="text-center"
            >
              <v-card
                :class="virtualSafeId ? 'success--text' : 'grey--text'"
                class="mx-auto mt-0 d-inline-flex v-card--account"
                outlined
                height="106"
                width="106"
              >
                <v-icon
                  class="mx-auto"
                  size="96"
                >
                  mdi-memory
                </v-icon>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="8"
            >
              <v-text-field
                v-model="virtualSafeId"
                v-validate="'required'"
                :rules="rules"
                color="secondary"
                label="Virtual Safe Id (Generated)"
                validate-on-blur
                data-vv-name="virtualSafeId"
              />
            </v-col>
          </v-row>
        </form>
      </v-tab-item>
      <v-tab-item class="pb-12">
        <div class="text-center display-2 black--text font-weight-light mb-6">
          Please review the summary.
        </div>

        <form
          action=""
          data-vv-scope="summary"
        >
          <v-row
            class="mx-auto"
            justify="space-around"
            style="max-width: 700px;"
          >
            <v-col
              cols="auto"
              class="text-center"
            >
              <v-card
                :class="virtualSafeId ? 'success--text' : 'grey--text'"
                class="mx-auto mt-0 d-inline-flex v-card--account"
                outlined
                height="106"
                width="106"
              >
                <v-icon
                  class="mx-auto"
                  size="96"
                >
                  mdi-home-plus
                </v-icon>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="8"
            >
              <div class="display-1 black--text font-weight-light">
                Site Name: {{ sitename }} <br>
                Group: {{ group }} <br>
                Using POSTAL Virtual safe UnitID:<br>{{ virtualSafeId }} <br>
                EOD Time of: {{ onboardEodTime }} <br>
              </div>
            </v-col>
          </v-row>
        </form>
      </v-tab-item>
    </base-material-wizard-site>
  </v-container>
</template>

<script>
  import { nanoid } from 'nanoid'

  export default {
    name: 'DashboardFormsWizard',
    data: () => ({
      safeid: '',
      sitename: '',
      state: '',
      city: '',
      zipcode: '',
      address: '',
      contactname: '',
      shipmentspermonth: '',
      sitecontactnumber: '',
      sitecontactname: '',
      supportemail: '',
      supportnumber: '',
      group: '',
      virtualSafeId: '',
      max: 50,
      allowSpaces: true,
      unique: true,
      filterchars: true,
      onlyspace: false,
      loadedsites: '',
      sitenameRules: [
        v => !!v || 'Site name is required',
        v => (v && v.length <= 10) || 'Site name must be less than 10 characters',
      ],
      onboardEodTime: '',
      menueodtime: false,
      eodTime: 0,

      tab: 0,
      tabs: ['New', 'Safe', 'Summary']
    }),
    computed: {
      rules () {
        const rules = []
        if (this.unique) {
          const rule =
            v => (!this.loadedsites.includes(v)) ||
              'Values must be unique and not be an existing site name'

          rules.push(rule)
        }
        if (!this.onlyspace) {
          const rule =
            v => v.trim().length || 'Name can not be only whitespace characters'

          rules.push(rule)
        }
        if (this.max) {
          const rule =
            v => (v || '').length <= this.max ||
              `A maximum of ${this.max} characters is allowed in a site name`

          rules.push(rule)
        }

        if (!this.allowSpaces) {
          const rule =
            v => (v || '').indexOf(' ') < 0 ||
              'No spaces are allowed'

          rules.push(rule)
        }
        if (this.filterchars) {
          const rule =
            v => !v.match(/\\t|[#\$\.]/gi) || ' $ # [ ] tabs are not allowed in a site name'
          rules.push(rule)
        }
        return rules
      },
      scope () {
        if (this.tab === 0) return 'new'
        else if (this.tab === 2) return 'summary'
        return 'safe'
      },
      grouplist () {
        // return []
        let groups = this.$store.getters.usergroups.map(
          group => group.name
        )
        return groups
      },
      allunits () {
        return this.$store.getters.ssunits.map(unit => unit.crypto_idnum)
      },
      getstates () {
        let state_hash = [
          'AL',
          'AK',
          'AS',
          'AZ',
          'AR',
          'CA',
          'CO',
          'CT',
          'DE',
          'DC',
          'FM',
          'FL',
          'GA',
          'GU',
          'HI',
          'ID',
          'IL',
          'IN',
          'IA',
          'KS',
          'KY',
          'LA',
          'ME',
          'MH',
          'MD',
          'MA',
          'MI',
          'MN',
          'MS',
          'MO',
          'MT',
          'NE',
          'NV',
          'NH',
          'NJ',
          'NM',
          'NY',
          'NC',
          'ND',
          'MP',
          'OH',
          'OK',
          'OR',
          'PW',
          'PA',
          'PR',
          'RI',
          'SC',
          'SD',
          'TN',
          'TX',
          'UT',
          'VT',
          'VI',
          'VA',
          'WA',
          'WV',
          'WI',
          'WY'
        ]
        return state_hash
      },
      getunassignedunits () {
        // get a list of profiles which are sites with safes assigned to them
        // get a list of all safe ids
        // return the list of unassigned safes
        let siteprofiles = this.$store.getters.loadedSiteProfiles
        let totalunits = this.$store.getters.ssunits
        let assignedsafes = []
        let sitenames = Object.keys(siteprofiles)
        for (let site of sitenames) {
          // console.log(site)
          if (siteprofiles[site].siteunitsprofile) {
            // console.log(siteprofiles[site].siteunitsprofile[0].crypto_idnum)
            if (siteprofiles[site].siteunitsprofile[0]) {
              assignedsafes.push(siteprofiles[site].siteunitsprofile[0].crypto_idnum)
            }
          }
        }
        let unassigned = totalunits.filter(unitrec => {
          if (!assignedsafes.includes(unitrec.crypto_idnum)) {
            return unitrec
          }
        })
        return unassigned.map(unit => unit.crypto_idnum)
      },
      availableSteps () {
        const steps = [0]

        if (this.sitename && this.onboardEodTime) { steps.push(1) }

        if (this.virtualSafeId && steps.includes(1)) steps.push(2)
        if (
          this.virtualSafeId &&
          this.onboardEodTime &&
          this.sitename &&
          steps.includes(2)
        ) steps.push(3)

        return steps
      }
    },
    watch: {
      sitename: 'validateField',
      max: 'validateField',
      model: 'validateField',
    },
    created () {
      this.virtualSafeId = 'PostalSafe-' + nanoid()
      this.$store.dispatch('loadSiteConfigs')
      this.$store.dispatch('loadunits')
      this.$store.dispatch('loadsiteProfiles')
      this.loadedsites = [...new Set(this.$store.getters.loadedSites.map(data => data.idnum))]
    },

    methods: {
      validateField () {
        this.$refs.form1.validate()
      },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      next () {
        this.validateForm(this.scope).then(item => {
          if (!item) return
          if (this.tab === 0) {
          }

          if (this.tab === this.tabs.length - 1) {
            this.$validator.fields.items.forEach(f => {
              f.reset()
              f.name = ''
            })
            let rec = {
              idnum: this.sitename,
              group: this.group,
              time_eod: this.onboardEodTime,
              safeid: this.virtualSafeId
            }
            this.$store.dispatch('createSiteWizard', rec)
            this.$store.dispatch('loadSiteConfigs')
            this.safeid = null
            this.sitename = null
            this.group = null
            this.tab = 0
            this.onboardEodTime = ''
            this.eodTime = 0
            this.virtualSafeId = 'PostalSafe-' + nanoid()
            // call wizzard sitesetup
            alert('The site has been added')
          } else {
            this.tab++
          }
        })
      },
      validateForm (scope) {
        return this.$validator.validateAll(scope)
      }
    }
  }
</script>

<style lang="sass">
  .v-card.v-card.v-card--account
    border-color: currentColor
    border-width: 4px

    .v-icon
      color: inherit

  .v-card--account,
  .v-card--account:before
    border-radius: 50%

</style>
